import script from "./orderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./orderManagement.vue?vue&type=script&setup=true&lang=js"

import "./orderManagement.vue?vue&type=style&index=0&id=4ff4644f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff4644f"]])

export default __exports__